import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from '../../../'; // If you want to use e.g. `next/link`, make your own wrapper like this:
//   import Link from 'next/link';
//   const LinkWrapper = ({ href, ...props }) => (
//     <Link href={href}>
//       <a {...props} />
//     </Link>
//   );
// and pass it as a `LinkWrapper` prop to `CommonChrome`.
// You can also provide an overridden `LinkWrapper` prop for any individual
// link in the `navLinks` prop you pass to `CommonChrome`.

export var DefaultLinkWrapper = function DefaultLinkWrapper(props) {
  return /*#__PURE__*/React.createElement("a", props, props.children);
};

var NavItem = /*#__PURE__*/function (_React$Component) {
  _inherits(NavItem, _React$Component);

  var _super = _createSuper(NavItem);

  function NavItem() {
    _classCallCheck(this, NavItem);

    return _super.apply(this, arguments);
  }

  _createClass(NavItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          href = _this$props.href,
          icon = _this$props.icon,
          isActive = _this$props.isActive,
          isOpen = _this$props.isOpen,
          hasSub = _this$props.hasSub,
          _this$props$LinkWrapp = _this$props.LinkWrapper,
          LinkWrapper = _this$props$LinkWrapp === void 0 ? DefaultLinkWrapper : _this$props$LinkWrapp,
          newTab = _this$props.newTab,
          rest = _objectWithoutProperties(_this$props, ["children", "className", "href", "icon", "isActive", "isOpen", "hasSub", "LinkWrapper", "newTab"]);

      var props = _objectSpread({
        className: classNames(className, 'nav-link', {
          'is-active': isActive,
          'is-open': isOpen,
          'has-sub': hasSub
        })
      }, rest);

      if (newTab) {
        props.target = '_blank';
        props.rel = 'noopener noreferrer';
      }

      var content = icon ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "nav-icon-wrapper"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: icon
      })), children) : children;
      var item = href ? /*#__PURE__*/React.createElement(LinkWrapper, _extends({
        href: href
      }, props), content) : /*#__PURE__*/React.createElement("button", props, content);
      return item;
    }
  }]);

  return NavItem;
}(React.Component);

_defineProperty(NavItem, "propTypes", {
  className: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.string,
  isActive: PropTypes.bool,
  isOpen: PropTypes.bool,
  hasSub: PropTypes.bool,
  newTab: PropTypes.bool,
  LinkWrapper: PropTypes.func
});

export default NavItem;